import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Office365GroupContext } from "../../context/Office365GroupContext";

export const useOffice365GroupInfo = () => {
    const [state, setState] = useState({ isLoaded: false, error: null });
    const { authState } = useOktaAuth();
    const { groupModule, setGroupModule } = useContext(Office365GroupContext);

    useEffect(() => {
        const fetchGroupData = async () => {
            setState((prev) => ({ ...prev, isLoaded: false, error: null }));

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/groups/office365/read`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: authState.accessToken.accessToken,
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({ groupId: groupModule.id }),
                    }
                );

                if (!response.ok) {
                    let message = `Request failed with status ${response.status}`;
                    try {
                        const errorData = await response.json();
                        message =
                            errorData?.error?.message ||
                            errorData?.message ||
                            `${response.status} ${response.statusText}`;
                    } catch {
                        // response body wasn't JSON — use the status-based message
                    }
                    throw new Error(message);
                }

                const data = await response.json();

                setGroupModule((prev) => ({
                    ...prev,
                    data,
                    isLoaded: true,
                }));

                setState((prev) => ({ ...prev, isLoaded: true }));
            } catch (error) {
                setState((prev) => ({ ...prev, isLoaded: true, error }));
            }
        };

        fetchGroupData();
    }, [authState, groupModule?.id]);

    return state;
};
